import {fetchSpecsheet} from '../slices/specsheetSlice';

export const kirbySpecsheetMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'status/setLang') {
        // pick section config base on ProductModel
		store.dispatch(fetchSpecsheet());
	}
    return result;
};
